import React, {useRef} from "react";
import PropTypes from "prop-types";
import {getCustomerSlotDetails} from "../../services/SessionStorage";
import {getThemeText} from "../../theme";
import {Stepper} from "../../falabella-components";

export const StepperWrapper = ({current, status}) => {
  const customerSlotDetails = useRef(getCustomerSlotDetails());
  const theme = getThemeText(customerSlotDetails);

  return (
    <div style={{margin: "20px auto", width: "100%"}}>
      <Stepper
        current={current}
        currentStatus={status}
        items={["Seleccionar", "Reservar", "Confirmar"]}
        theme={theme}
      />
    </div>
  );
};

StepperWrapper.propTypes = {
  current: PropTypes.number,
  status: PropTypes.string,
};

StepperWrapper.defaultProps = {
  current: 0,
  status: "active",
};
